module.exports = "<app-map></app-map>\n\n\n<router-outlet></router-outlet>\n"